import { createContext, useContext, useMemo, useState } from 'react';

interface NotificationContextProp {
    notificationCount: number;
    onReceipt: (notification: any) => void;
}

const NotificationsContext = createContext<Partial<NotificationContextProp>>({});

export const useNotificationsContext = () => useContext(NotificationsContext);

export const NotificationsProvider: React.FC = ({ children }) => {
    const [notifications, setNotifications] = useState([]);

    // TODO: update this module when we implement live notifications

    const notificationCount = useMemo(() => {
        return notifications.length;
    }, [notifications]);

    const onReceipt = (notification: any) => {
        setNotifications((previousState) => [...previousState, notification]);
    };

    return (
        <NotificationsContext.Provider value={{ notificationCount, onReceipt }}>
            {children}
        </NotificationsContext.Provider>
    );
};
